"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _toConsumableArray2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.match");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _lang = _interopRequireDefault(require("@/lang"));

var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));

var _validate = require("@/utils/validate");

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var defaultProps = {
  children: "childs",
  label: "title"
};
var _default = {
  name: "agent:view",
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['smsNumberAreaOption', 'statusOptions', 'informationOptions', 'netwayCodeOption', 'forceBindGoogleOption', 'storedGoogleStatusOption']), {
    errorInfo: function errorInfo() {
      return {
        emptyAgentName: this.$t('SMS.username') + this.$t('SMS.canNotBeEmpty'),
        invalidAccountNameLength: this.$t('message.message72'),
        invalidAccountName: this.$t('message.message74'),
        emptyPassword: this.$t('SMS.password') + this.$t('SMS.canNotBeEmpty'),
        emptyPayPassword: this.$t('SMS.payPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyConfirmPassword: this.$t('SMS.confirmPassword') + this.$t('SMS.canNotBeEmpty'),
        invalidPayPasswordLength: this.$t('message.message73'),
        invalidPasswordLength: this.$t('message.organizationManagementMessage13'),
        invalidPasswordFormat: this.$t('warningMessage.passwordFormatNoUpperMessage'),
        organizationManagementMessage14: this.$t("message.organizationManagementMessage14")
      };
    },
    rules: function rules() {
      var _this2 = this;

      var checkPasswordFormat = function checkPasswordFormat(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (_this2.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this2.errorInfo.invalidPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this2.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      var checkPayPasswordFormat = function checkPayPasswordFormat(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (_this2.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyPayPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this2.errorInfo.invalidPayPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this2.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      var checkAccountFormat = function checkAccountFormat(rule, value, callback) {
        var length;
        var minlength = 6;
        var maxlength = 20;

        if (_this2.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyAgentName));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this2.errorInfo.invalidAccountNameLength));
        }

        if (/.*[\u4e00-\u9fa5|\！|\，|\。|\（|\）|\《|\》|\“|\”|\？|\：|\；|\【|\】]+.*/.test(value)) {
          return callback(new Error(_this2.errorInfo.invalidAccountName));
        } else {
          return callback();
        }
      };

      var checkPassword = function checkPassword(rule, value, callback) {
        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyConfirmPassword));
        }

        if (_this2.formTemp.agentPassword !== value) {
          return callback(new Error(_this2.errorInfo.organizationManagementMessage14));
        }

        return callback();
      };

      return {
        agentName: [{
          required: true,
          message: _lang.default.t("SMS.agentName") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        stateCode: [{
          required: true,
          message: _lang.default.t("SMS.status") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        agentAccount: [{
          required: true,
          validator: checkAccountFormat,
          trigger: "blur"
        }],
        payPassword: [{
          required: true,
          validator: checkPayPasswordFormat,
          trigger: "blur"
        }],
        agentPassword: [{
          required: true,
          validator: checkPasswordFormat,
          trigger: "blur"
        }],
        checkPassword: [{
          required: true,
          validator: checkPassword,
          trigger: "blur"
        }]
      };
    }
  }),
  data: function data() {
    return {
      link: "null",
      dialogFormVisible: false,
      dialogTreeVisible: false,
      dialogQrcodeVisible: false,
      batchUpdatePermissionFlag: false,
      list: null,
      total: 0,
      listLoading: true,
      formLoading: false,
      time: null,
      dialogType: "",
      multipleSelection: [],
      upAgentOption: [],
      agentOption: [],
      permissionTree: [],
      userLimit: [],
      channelList: [],
      defaultProps: defaultProps,
      areaOption: null,
      hasGoogleKey: true,
      isDisabled: false,
      textMap: {
        update: _lang.default.t("common.update"),
        create: _lang.default.t("common.addNew"),
        permission: _lang.default.t("common.permission"),
        cost: _lang.default.t("common.cost")
      },
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        agentId: "",
        organizationCode: "",
        organizationName: "",
        description: "",
        status: "",
        isGoogle: "",
        approveStateCode: ""
      },
      copyCostParameter: {
        sourceAgentId: "",
        targetAgentId: []
      },
      costRowAgentId: "",
      costRules: {
        name: [{
          required: true,
          message: _lang.default.t("SMS.tariffName") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        value: [{
          required: true,
          message: _lang.default.t("SMS.tariff") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        smsType: [{
          required: true,
          message: _lang.default.t("SMS.smsType") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        channelId: [{
          required: true,
          message: _lang.default.t("SMS.smsType") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      },
      rechargeRules: {
        netwayCode: [{
          required: true,
          message: _lang.default.t("SMS.netwayCode") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        processRechargeAmount: [{
          required: true,
          message: _lang.default.t("SMS.rechargeAmount") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        verifyCode: [{
          required: true,
          message: _lang.default.t("SMS.verificationCode") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }],
        payPassword: [{
          required: true,
          message: _lang.default.t("SMS.payPassword") + _lang.default.t("SMS.canNotBeEmpty"),
          trigger: "blur"
        }]
      },
      formTemp: {},
      costTempBuffer: [],
      rechargeTemp: {},
      key: 1,
      qrcodeTemp: {
        googleQrcode: null,
        agentAccount: null
      },
      toBeUncheck: [],
      toBeCheck: [],
      monitor: false
    };
  },
  created: function created() {
    if (this.$store.getters.isAgent) {
      this.checkGoogleKeyInAgent();
    }

    if (this.$store.getters.isAdmin) {
      this.getUpAgent();
    }

    this.getAgent();
    this.getList();
  },
  methods: {
    convertForceGoogleOptionName: function convertForceGoogleOptionName(name) {
      var found = '';
      this.forceBindGoogleOption.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertGoogleStatusOptionName: function convertGoogleStatusOptionName(name) {
      var found = '';
      this.storedGoogleStatusOption.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    handleCheck: function handleCheck(node, _ref) {
      var _this3 = this;

      var checkedKeys = _ref.checkedKeys;
      var status = checkedKeys.includes(node.data.menuId.toString());

      if (!status && node.childs.length && this.monitor) {
        this.toBeUncheck.push(parseInt(node.data.menuId));
        this.uncheckChilds(node.childs);
        this.$nextTick(function () {
          var _userLimit = (0, _toConsumableArray2.default)(_this3.userLimit);

          _userLimit = _userLimit.filter(function (menu) {
            return !_this3.toBeUncheck.includes(menu);
          });
          _this3.toBeUncheck = [];
          _this3.userLimit = _userLimit;

          _this3.$refs.tree.setCheckedKeys(_this3.userLimit);
        });
      }

      if (status && this.monitor) {
        this.toBeCheck.push(parseInt(node.data.menuId));
        this.checkChilds(node);
        this.checkParents(node);
        this.$nextTick(function () {
          var _userLimit = (0, _toConsumableArray2.default)(_this3.userLimit);

          _this3.toBeCheck.forEach(function (key) {
            if (!_userLimit.includes(key)) {
              _userLimit.push(key);
            }
          });

          _this3.userLimit = _userLimit;
          _this3.toBeCheck = [];

          _this3.$refs.tree.setCheckedKeys(_this3.userLimit);
        });
      }
    },
    uncheckChilds: function uncheckChilds(childs) {
      var _this4 = this;

      childs.forEach(function (child) {
        _this4.toBeUncheck.push(parseInt(child.data.menuId));

        if (child.childs.length) _this4.uncheckChilds(child.childs);
      });
    },
    checkParents: function checkParents(node) {
      if (!node) return;
      this.toBeCheck.push(parseInt(node.parentId));
      var parentNode = this.findNodeById(this.permissionTree, parseInt(node.parentId));
      this.checkParents(parentNode);
    },
    checkChilds: function checkChilds(node) {
      var _this5 = this;

      if (node.childs.length) {
        node.childs.forEach(function (child) {
          _this5.toBeCheck.push(parseInt(child.data.menuId));

          _this5.checkChilds(child);
        });
      }
    },
    findNodeById: function findNodeById(tree, id) {
      var result;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tree[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;
          if (parseInt(node.data.menuId) === id) return node;

          if (node.childs.length) {
            result = this.findNodeById(node.childs, id);
            if (result) break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    convertStatusName: function convertStatusName(name) {
      var found = "";
      this.statusOptions.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertUpAgentName: function convertUpAgentName(name) {
      var found = name;
      this.upAgentOption.forEach(function (status) {
        if (parseInt(status.agentId) == name) {
          found = status.agentName;
          return;
        }
      });
      return found;
    },
    checkGoogleKeyInAgent: function checkGoogleKeyInAgent() {
      var _this6 = this;

      _httpUtils.default.post("agentUser", "existQrCode", null, null).then(function (agent) {
        if (agent.data === false) {
          _this6.hasGoogleKey = false;
        }
      }).catch(function (err) {
        _this6.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    getUpAgent: function getUpAgent() {
      var _this7 = this;

      _httpUtils.default.post("agent", "getUpAgents", null, null).then(function (agent) {
        _this7.upAgentOption = agent.data;
      }).catch(function (err) {
        _this7.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    getAgent: function getAgent() {
      var _this8 = this;

      _httpUtils.default.post("agent", "getAgents", null, null).then(function (agent) {
        _this8.agentOption = agent.data;
      }).catch(function (err) {
        _this8.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    getList: function getList() {
      var _this9 = this;

      if (!this.hasViewPermission) {
        return;
      }

      this.listLoading = true;

      _httpUtils.default.post("agent", "list", null, this.listQuery).then(function (res) {
        var index = 0;
        _this9.list = res.data.rows;
        _this9.total = res.data.total;
        setTimeout(function () {
          _this9.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this9.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList();
    },
    resetFormTemp: function resetFormTemp() {
      var _this10 = this;

      this.formTemp = {
        id: "",
        upAgentId: "",
        agentName: "",
        agentAccount: "",
        agentState: "",
        loginFaildCount: "",
        createDate: "",
        agentPassword: "",
        createUser: "",
        stateCode: "",
        qq: "",
        isGoogle: "1",
        description: "",
        email: "",
        phoneNumber: "",
        remark: ""
      };
      this.$nextTick(function () {
        return _this10.$refs["dataForm"] ? _this10.$refs["dataForm"].clearValidate() : null;
      });
    },
    resetPermissionTree: function resetPermissionTree() {
      this.permissionTree = [];
      this.userLimit = [];
    },
    resetQrcodeData: function resetQrcodeData() {
      this.qrcodeTemp = {
        googleQrcode: null,
        agentAccount: null
      };
    },
    handleCreate: function handleCreate() {
      var _this11 = this;

      this.resetFormTemp();
      this.formTemp.redisBill = "0";
      this.formTemp.isGoogle = "1";
      this.dialogType = "create";
      this.$nextTick(function (_) {
        _this11.dialogFormVisible = true;
      });
    },
    handleCost: function handleCost(row) {
      this.$router.push({
        name: "agentCost:view",
        params: {
          agentId: row.id
        }
      });
    },
    handleUpdatePermission: function handleUpdatePermission(row) {
      this.resetPermissionTree();
      this.getPermissionData(row);
      this.dialogType = "permission";
      this.dialogTreeVisible = true;
    },
    handleBatchUpdatePermission: function handleBatchUpdatePermission() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t('warningMessage.selectUserToUpdatePermissionMessage'),
          type: 'error'
        });
      } else {
        this.resetPermissionTree();
        this.getPermissionDataForBatchUpdate();
        this.batchUpdatePermissionFlag = true;
        this.dialogType = "permission";
        this.dialogTreeVisible = true;
      }
    },
    handleQrcode: function handleQrcode(row) {
      this.resetQrcodeData();
      this.getQrcodeData(row);
      this.dialogType = "Qrcode";
      this.dialogQrcodeVisible = true;
    },
    getRowData: function getRowData(row) {
      this.formTemp = {
        id: row.id,
        upAgentId: row.upAgentId,
        agentName: row.agentName,
        agentAccount: row.agentAccount,
        agentState: row.agentState,
        loginFaildCount: row.loginFaildCount,
        createDate: row.createDate,
        stateCode: row.stateCode,
        qq: row.qq,
        isGoogle: row.isGoogle,
        description: row.description,
        email: row.email,
        phoneNumber: row.phoneNumber,
        remark: row.remark
      };
    },
    handleUpdate: function handleUpdate(row) {
      this.resetFormTemp();
      this.getRowData(row);
      this.dialogType = "update";
      this.dialogFormVisible = true;
    },
    handleDelete: function handleDelete(state) {
      var _this12 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === "delete") {
        message = _lang.default.t("warningMessage.batchCancelAgentConfirmMessage");
        info = _lang.default.t("SMS.alarm");
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t("permission.confirm"),
        cancelButtonText: _lang.default.t("permission.cancel"),
        type: "warning"
      }).then(function () {
        _this12.doDeleteData();
      }).catch(function () {
        _this12.$notify({
          type: "info",
          message: _lang.default.t("warningMessage.cancelAgentCancelledMessage")
        });
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    doDeleteData: function doDeleteData() {
      var _this13 = this;

      this.listLoading = true;
      var ids = "";

      for (var data in this.multipleSelection) {
        ids = ids === "" ? this.multipleSelection[data].id.toString() : ids.concat("," + this.multipleSelection[data].id.toString());
      }

      _httpUtils.default.post("agent", "cancel", null, ids).then(function (res) {
        if (res.code === 200) {
          _this13.$notify({
            title: _lang.default.t("SMS.success"),
            message: _lang.default.t("warningMessage.cancelAgentSuccessMessage"),
            type: "success",
            duration: 2000
          });

          _this13.resetFormTemp();

          _this13.getList();
        }
      }).catch(function (e) {
        _this13.$notify({
          showClose: true,
          message: _lang.default.t("message.message5") + e.message,
          type: "warning"
        });

        _this13.listLoading = false;
      });
    },
    doCreateData: function doCreateData() {
      var _this14 = this;

      // this.formLoading = true;
      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this14.formLoading = true;

          _httpUtils.default.post("agent", "add", null, _this14.formTemp).then(function (res) {
            if (res.code === 200) {
              _this14.$notify({
                title: _lang.default.t("message.message6"),
                message: res.data,
                type: "success",
                duration: 2000
              });

              _this14.dialogFormVisible = false;
              setTimeout(function () {
                _this14.resetFormTemp();

                _this14.getList();

                _this14.formLoading = false;
              }, 1 * 1000);
            }
          }).catch(function (err) {
            _this14.$notify({
              showClose: true,
              message: _lang.default.t("message.message40") + ',' + err.message,
              type: "warning"
            });

            _this14.formLoading = false;
          });
        }
      });
    },
    doUpdateData: function doUpdateData() {
      var _this15 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          _this15.formLoading = true;

          _httpUtils.default.post("agent", "update", null, _this15.formTemp).then(function (res) {
            if (res.code === 200) {
              _this15.$notify({
                title: _lang.default.t("SMS.success"),
                message: _lang.default.t("message.message41"),
                type: "success",
                duration: 2000
              });

              _this15.dialogFormVisible = false;
              _this15.formLoading = false;
              setTimeout(function () {
                _this15.resetFormTemp();

                _this15.getList();
              }, 1 * 1000);
            }
          }).catch(function (e) {
            _this15.formLoading = false;

            _this15.$notify({
              showClose: true,
              message: _lang.default.t("message.message42") + ',' + e.message,
              type: "warning"
            });
          });
        }
      });
    },
    getPermissionData: function getPermissionData(row) {
      var _this16 = this;

      this.currentID = row.id;

      _httpUtils.default.post("agentMenu", "tree", null, {}).then(function (res) {
        _this16.permissionTree = res.data;

        _httpUtils.default.post("agentMenu", "getMenuKeys", null, _this16.currentID).then(function (res) {
          _this16.userLimit = res.data;

          _this16.$refs.tree.setCheckedKeys(_this16.userLimit);

          _this16.monitor = true;
        }).catch(function (err) {
          _this16.$message({
            message: err.message,
            type: 'error'
          });
        });
      }).catch(function (err) {
        _this16.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    getPermissionDataForBatchUpdate: function getPermissionDataForBatchUpdate() {
      var _this17 = this;

      _httpUtils.default.post("agentMenu", "getAllTree", null, null).then(function (res) {
        _this17.permissionTree = res.data;

        _this17.$refs.tree.setCheckedKeys([]);
      }).catch(function (err) {
        _this17.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    checkSelection: function checkSelection() {
      var message, info;

      if (this.multipleSelection === undefined ? true : this.multipleSelection === null ? true : this.multipleSelection.length === 0) {
        message = _lang.default.t("message.message16");
        info = _lang.default.t("SMS.alarm");
        this.$message(message, info, {
          confirmButtonText: _lang.default.t("permission.confirm"),
          type: "warning"
        });
        return true;
      }
    },
    isMobile: function isMobile(rule, value, callback) {
      var reg = /^1[3456789]\d{9}$/;

      if (!reg.test(parseInt(value))) {
        return callback(new Error());
      }

      return callback();
    },
    handleResetPassword: function handleResetPassword(state) {
      var _this18 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === "resetPassword") {
        message = _lang.default.t("message.message35");
        info = _lang.default.t("SMS.alarm");
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t("permission.confirm"),
        cancelButtonText: _lang.default.t("permission.cancel"),
        type: "warning"
      }).then(function () {
        _this18.doResetPasswordData();
      }).catch(function () {
        _this18.$notify({
          type: "info",
          message: _lang.default.t("message.message36")
        });
      });
    },
    doResetPasswordData: function doResetPasswordData() {
      var _this19 = this;

      var accounts = '';

      for (var data in this.multipleSelection) {
        accounts = accounts === "" ? this.multipleSelection[data].agentAccount.toString() : accounts.concat(',' + this.multipleSelection[data].agentAccount.toString());
      }

      var _this = this;

      _httpUtils.default.post("agent", "resetPassword", null, accounts).then(function (res) {
        if (res.code === 200) {
          _this.$alert(_this.$t("message.message37") + _this.$t('message.message64') + " " + res.message + " " + _this.$t("system.user.userTable.resetSuccessInfo"), _this.$t("SMS.success"), {
            confirmButtonText: _this.$t("common.confirm")
          });

          _this19.getList();
        }
      }).catch(function (e) {
        _this19.$notify({
          showClose: true,
          message: _lang.default.t("message.message38") + e.message,
          type: "warning"
        });
      });
    },
    handleResetTree: function handleResetTree() {
      this.userLimit = [];
      this.dialogTreeVisible = false;
      this.resetPermissionTree();
    },
    doPermissionUpdate: function doPermissionUpdate() {
      var _this20 = this;

      var nodeKeys;

      if (this.$refs.tree.getCheckedKeys().length != 0) {
        nodeKeys = this.$refs.tree.getCheckedKeys().reduce(function (a, b) {
          if (a != null && b == null) {
            return a;
          }

          return a.concat("," + b);
        });
      } else {
        nodeKeys = "";
      }

      var data = null;

      if (this.batchUpdatePermissionFlag) {
        this.$confirm(_lang.default.t('warningMessage.batchUpdatePermissionConfirmMessage'), _lang.default.t('warningMessage.batchUpdatePermissionMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          var agentIds = [];

          for (var item in _this20.multipleSelection) {
            agentIds.push(_this20.multipleSelection[item].id);
          }

          if (nodeKeys.length == 0) {
            data = {
              menuIds: "",
              agentIds: agentIds
            };
          } else {
            data = {
              "eleTree-node": "on",
              menuIds: nodeKeys,
              agentIds: agentIds
            };
          }

          _httpUtils.default.post("agentMenuLimit", "updatesByAgentIds", null, data).then(function (res) {
            if (res.code === 200) {
              _this20.$notify({
                title: _lang.default.t("SMS.success"),
                message: _lang.default.t("warningMessage.batchUpdatePermissionSuccessMessage"),
                type: "success",
                duration: 2000
              });

              _this20.handleResetTree();

              _this20.batchUpdatePermissionFlag = false;

              _this20.getList();
            }
          }).catch(function (e) {
            _this20.$notify({
              showClose: true,
              message: _lang.default.t("message.organizationManagementMessage44") + e.message,
              type: "warning"
            });
          });
        });
      } else {
        this.$confirm(_lang.default.t('warningMessage.updatePermissionConfirmMessage'), _lang.default.t('warningMessage.updatePermissionMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          if (nodeKeys.length == 0) {
            data = {
              menuIds: "",
              agentId: _this20.currentID
            };
          } else {
            data = {
              "eleTree-node": "on",
              menuIds: nodeKeys,
              agentId: _this20.currentID
            };
          }

          _httpUtils.default.post("agentMenuLimit", "updates", null, data).then(function (res) {
            if (res.code === 200) {
              _this20.$notify({
                title: _lang.default.t("SMS.success"),
                message: _lang.default.t("warningMessage.updatePermissionSuccessMessage"),
                type: "success",
                duration: 2000
              });

              _this20.dialogTreeVisible = false;
              _this20.currentID = null;

              _this20.getList();
            }
          }).catch(function (e) {
            _this20.$notify({
              showClose: true,
              message: _lang.default.t("message.organizationManagementMessage44") + e.message,
              type: "warning"
            });
          });
        });
      }
    },
    getQrcodeData: function getQrcodeData(row) {
      var _this21 = this;

      _httpUtils.default.post("agent", "getQrcode", null, row.id).then(function (res) {
        _this21.qrcodeTemp = res.data;

        if (res.data.googleQrcode != "null") {
          _this21.qrcode(res.data.googleQrcode);
        } else {
          document.getElementById("qrcode").innerHTML = _lang.default.t("SMS.unboundVerificationCode");
        }
      }).catch(function (err) {
        _this21.$message({
          message: err.message,
          type: 'error'
        });
      });

      ;
    },
    qrcode: function qrcode(link) {
      document.getElementById("qrcode").innerHTML = "";
      var that = this;
      var qrcode = new _qrcodejs.default("qrcode", {
        width: 250,
        height: 250,
        // 高度
        text: link // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // backgrounds: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色

      });
    },
    handleForceLogoff: function handleForceLogoff(id, userName) {
      var _this22 = this;

      this.$confirm(_lang.default.t('warningMessage.forceLogoffConfirmMessage'), _lang.default.t('warningMessage.forceLogoffMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this22.listLoading = true;

        _httpUtils.default.post("agent", "forceLogoff", null, id).then(function (res) {
          var content = _lang.default.t('warningMessage.forceLogoffMessage') + " " + userName + " " + _lang.default.t('common.success');

          _this22.$message({
            message: content,
            type: 'success'
          });

          _this22.getList();
        });
      }).catch(function (error) {
        _this22.$message({
          message: error.message,
          type: 'error'
        });
      });
      setTimeout(function () {
        _this22.listLoading = false;
      }, 1 * 1000);
    },
    handleCopyCost: function handleCopyCost() {
      var _this23 = this;

      if (this.copyCostParameter.sourceAgentId === '' || this.copyCostParameter.sourceAgentId === null || this.copyCostParameter.targetAgentId === null || this.copyCostParameter.targetAgentId.length == 0) {
        this.$message({
          message: _lang.default.t('warningMessage.pleaseSelectSourceAgentAndTargetAgentMessage'),
          type: 'error'
        });
      } else {
        _httpUtils.default.post("agentCost", "copyCost", null, this.copyCostParameter).then(function (res) {
          if (res.code === 200) {
            _this23.$notify({
              title: _lang.default.t("SMS.success"),
              message: _lang.default.t("warningMessage.copyAgentCostSuccessMessage"),
              type: "success",
              duration: 2000
            });

            _this23.handleResetCopyCost();
          } else {
            _this23.$message({
              showClose: true,
              message: res.message,
              type: "warning"
            });
          }
        }).catch(function (err) {
          _this23.$message({
            message: err.message,
            type: 'error'
          });
        });
      }
    }
  }
};
exports.default = _default;